// extracted by mini-css-extract-plugin
export default {"item":"lessonItem_item__KQdXh","itemMobile":"lessonItem_itemMobile__vSVi9"};